// Pick the best identification copy for the current UI language.
// Falls back to the scan's original identification if no cached translation exists.
export const localizedIdentification = (scan, userLang) => {
  if (!scan) return null;
  const lang = userLang || "en";
  if (scan.language === lang) return scan.identification;
  const cached = scan.translations && scan.translations[lang];
  return cached || scan.identification;
};
